import React from 'react';

import { colors } from '@styleseat/brand';
import withStore from '../../../withStore';
import NotificationBanner from '../NotificationBanner';
import FLAME_ICON from '../../../../../images/flame.svg';
import useLinkTo from '../../../../hooks/useLinkTo';
import { useJanitor } from '../../../../hooks';
import { extendSearchBoostEligibleDate } from '../../../../modules/Api';

type Notification = {
  type: string,
  provider_id: number,
  creation_time: string,
  uuid: string,
};

type ExtendSearchBoostEligibilityNotificationProps = {
  notification: Notification,
};

const ExtendSearchBoostEligibilityNotification = ({
  notification,
}: ExtendSearchBoostEligibilityNotificationProps) => {
  const linkTo = useLinkTo();
  const { provider_id: providerId } = notification;

  const janitor = useJanitor();

  const handleExtendButtonClick = () => {
    janitor.addPromise(extendSearchBoostEligibleDate(providerId))
      .then(() => {
        const routeParams = {
          providerId,
          view: 'timeline',
          reload: true,
        };

        linkTo('provider.todayNext', routeParams);
      });
  };

  const buttonProps = {
    appearance: 'text-light',
    size: 'small',
    text: 'Extend My Time',
    onClick: handleExtendButtonClick,
    clickTracking: {
      name: 'pro_notification_extend_search_boost_eligibility_clicked',
      params: {
        notification_type: 'extend_search_boost_eligibility',
        provider_id: providerId,
      },
    },
  };

  return (
    <NotificationBanner
      notification={notification}
      icon={FLAME_ICON}
      highlightedText="We&apos;re giving you extra time"
      text="to earn a search boost. Extend your time now."
      highlightBorderColor={colors.petal}
      highlightedSubText="Search Boost"
      subText="pushes your business to the top of client searches in your area."
      buttonProps={buttonProps}
    />
  );
};

export default withStore(ExtendSearchBoostEligibilityNotification);
